import { getUrlComponents } from "pro-features/components/AutocompleteWebsites/urlComponentUtils";
import type { IChosenItem } from "app/components/compare/WebsiteQueryBar/WebsitePageQueryBarUtils";

export const getExcludesFromDomains = (domains: string[]): IChosenItem[] =>
    domains.map((domain) => {
        const { subdomain } = getUrlComponents(domain);
        const searchType = subdomain ? "subdomain" : "domain";

        return {
            url: domain,
            icon: "",
            image: "",
            favicon: "",
            color: "",
            searchType,
            domain: subdomain ? undefined : domain,
            subdomain: subdomain || undefined,
            displayName: domain,
            name: domain,
            smallIcon: false as const,
        };
    });
